import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mediaList, type MediaType } from '@/mocks/movies';
import { categoryMeta, typeLabels } from '@/utils/media';

const order: MediaType[] = ['movie', 'tv', 'variety'];
const tones: Record<MediaType, string> = {
  movie: 'from-primary-950/90',
  tv: 'from-secondary-950/90',
  variety: 'from-accent-950/90',
};

export default function CategoryEntries() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
      <div className="mb-6 text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{t('categoryQuick')}</h2>
        <p className="mt-2 text-sm text-foreground-500">{t('categoryQuickDesc')}</p>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
        {order.map((type) => {
          const meta = categoryMeta[type];
          const banner = mediaList.find((m) => m.type === type)?.banner;
          const count = mediaList.filter((m) => m.type === type).length;
          return (
            <Link
              key={type}
              to={`/category/${type}`}
              className="group relative h-44 overflow-hidden rounded-lg md:h-52 cursor-pointer"
            >
              {banner ? (
                <img
                  src={banner}
                  alt={`${typeLabels[type]}分类`}
                  title={`${typeLabels[type]}分类频道`}
                  className="absolute inset-0 w-full h-full object-cover object-top transition duration-700 group-hover:scale-105"
                />
              ) : null}
              <div className={`absolute inset-0 bg-gradient-to-t ${tones[type]} via-primary-950/55 to-transparent`}></div>
              <div className="relative z-10 flex h-full flex-col justify-between p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-background-50/15 text-background-50 backdrop-blur">
                  <i className={`${meta.icon} text-2xl`}></i>
                </span>
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-xl font-bold text-background-50">{typeLabels[type]}</h3>
                    <span className="rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-accent-950">
                      {count} {t('itemCount')}
                    </span>
                  </div>
                  <p className="mt-1 line-clamp-1 text-xs text-background-100/80">{meta.desc}</p>
                  <span className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-accent-300 group-hover:gap-2 transition-all">
                    {t('viewAll')}
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}